const sendEvent = (event, player) => {
  player.contentWindow.postMessage(event, 'https://vk.com');
};

export const updateTimeToStart = (player) => {
  sendEvent({ method: 'seek', time: 0 }, player)
};

export const playVideo = (player) => {
  sendEvent({ method: 'play' }, player);
};

export const setMute = (value, player) => {
  sendEvent({ method: value ? 'mute' : 'unmute' }, player);
};
